module.exports = __webpack_public_path__ + "media/stylesheets/images/main/naver_symboli-5d35a6ece3fa9f4990419a3bfa871382.png";